import { render } from "./SnapshotEditDialog.vue?vue&type=template&id=0882a3cc"
import script from "./SnapshotEditDialog.vue?vue&type=script&lang=js"
export * from "./SnapshotEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__